<template>
  <div class="after-register">
    <!-- <h1>WTF</h1> -->
  </div>
</template>

<script>
export default {
  created() {
    // @FACEBOOK-PIXEL
    fbq('track', 'Contact');
    
    this.$router.push('/dashboard/farms/map-view');
  }
}
</script>

<style lang="css" scoped>
</style>
